import React from "react";
import { Switch, Route } from "react-router-dom";
import CashDelivery from "../../pages/cash_delivery/CashDelivery";
import ConfirmDelivery from "../../pages/cash_delivery/ConfirmDelivery";
import Home from "../../pages/Home";
import NotFound from "../../pages/NotFound";

import TransferMoney from "../../pages/transfer_money/TransferMoney";
import MoneyDeposited from "../../pages/transfer_money/money_deposite/MoneyDeposited";
import MoneyTransfer from "../../pages/transfer_money/money_transfer/MoneyTransfer";
import TransferReceipt from "../../pages/cash_delivery/TransferReceipt";
import HelpCenter from "../../pages/HelpCenter";
import Login from "../../pages/auth/Login";
import Transactions from "../../pages/transactions/Transactions";
import TransactionDetails from "../../pages/transactions/TransactionDetails";
import MoneyPicked from "../../pages/transfer_money/money_picked/MoneyPicked";
import ForgotPassword from "../../pages/auth/ForgotPassword";
import EmailSent from "../../pages/auth/OtpSend";
import ResetPassword from "../../pages/auth/ResetPassword";
import ResetSuccessful from "../../pages/auth/ResetSuccessful";
import Test from "../../pages/Test";
import AccountSettings from "../../pages/auth/account_settings/AccountSettings";
import ReceiverAuthentication from "../../pages/cash_delivery/ReceiverAuthentication";

import PrivateRoute from "./PrivateRoute";
import OtpSend from "../../pages/auth/OtpSend";
import TransferRequest from "../../pages/transfer_request/TransferRequest";

const Navigation = () => {
  return (
    <Switch>
      <Route path="/test">
        <Test />
      </Route>

      <Route path="/login">
        <Login />
      </Route>

      <Route path="/forgot-password">
        <ForgotPassword />
      </Route>
      <Route path="/email-sent">
        <EmailSent />
      </Route>
      <Route path="/otp-send">
        <OtpSend />
      </Route>
      <Route path="/reset-password">
        <ResetPassword />
      </Route>
      <Route path="/reset-successful">
        <ResetSuccessful />
      </Route>

      <PrivateRoute
        path="/receiver-authentication"
        component={ReceiverAuthentication}
      />
      <PrivateRoute path="/account-settings" component={AccountSettings} />

      <PrivateRoute path="/transactions" component={Transactions} />
      <PrivateRoute path="/transfer-request" component={TransferRequest} />
      <PrivateRoute
        path="/transaction-details"
        component={TransactionDetails}
      />
      <PrivateRoute path="/help-center" component={HelpCenter} />

      <PrivateRoute path="/money-deposited" component={MoneyDeposited} />
      <PrivateRoute path="/money-transfer" component={MoneyTransfer} />
      <PrivateRoute path="/money-picked" component={MoneyPicked} />
      <PrivateRoute path="/confirm-delivery" component={ConfirmDelivery} />
      <PrivateRoute path="/transfer-receipt" component={TransferReceipt} />
      <PrivateRoute path="/cash-delivery" component={CashDelivery} />
      <PrivateRoute path="/transfer-money" component={TransferMoney} />

      <PrivateRoute path="/home" exact component={Home} />
      <PrivateRoute path="/" exact component={Home} />
      <Route path="*" component={NotFound} />
    </Switch>
  );
};

export default Navigation;
